import { isFieldHidden } from './DependencyService';
import { replacePlaceholders } from './PlaceholderService';

export const getComponentProperties = (stepContentId, contentItem, index: number, additionalProperties) => {
	if (isFieldHidden(contentItem)) {
		// hide hidden fields
		return undefined;
	}
	// Map uniqueIdentifier?.uid to content.name
	const content = {
		...contentItem.content,
		name: contentItem.content.uniqueIdentifier?.uid ?? 'NO_UNIQUE_ID_FOR_CONTENT_ITEM',
	};

	const updatedComponentProps = {
		index,
		pageId: stepContentId.toString(),
		stepContentId: content.name,
		...additionalProperties,
		...content,
	};

	replacePlaceholders(updatedComponentProps);
	return updatedComponentProps;
};
